<template>
    <div class="clause-wrapper">
        <div class="clause-body">
            <header class="header">被保人同意确认书</header>
            <div class="content">
                <p>
                <span style="font-size:19px;font-family:宋体">本产品含有死亡保险责任，当被保险人与投保人不一致时，您（投保人）已经就该保险金额征得了被保险人的同意及认可（父母为其未成年子女投保的除外）</span>
                </p>
            
            </div>
            <div class="close-btn" @click="closeClause">关闭</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InsClause",
        methods:{
            closeClause(){
                this.$router.back(-1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .clause-wrapper{
        overflow: hidden;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 9999;
        .clause-body{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            color: #333;
            background-color: #fff;
            z-index: 9999;
            -webkit-transition: 300ms all;
            transition: 300ms all;
            .header{
                height: 13.33vw;
                line-height: 13.33vw;
                font-size: 4.8vw;
                font-weight: bold;
                border-bottom: .27vw solid #f5f5f9;
                text-align: center;
            }
            .content{
                height: 60vh;
                padding: 2.67vw 5vw;
                overflow: auto;
                text-align:justify;
                .title{
                    text-align: center;
                    font-size: 4.8vw;
                    font-weight: bold;
                    margin: 2vw 0;
                }
            }
            .close-btn{
                height: 12vw;
                line-height: 12vw;
                text-align: center;
                color: #ffffff;
                background: #3385ff;
            }
        }
    }
</style>